import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "designSystem/components/button/IconButton";
import Chip from "designSystem/components/chip/Chip";
import Grid from "designSystem/components/grid/Grid";
import MultiSelect from "designSystem/components/select/MultiSelect";
import { SingleSelect } from "designSystem/index";
import { useLocale } from "designSystem/locale";
import { ComponentItem } from "designSystem/types/component-item-types";
import _ from "lodash";
import { observer } from "mobx-react-lite";
import React, { Fragment, FunctionComponent } from "react";
import { Rule, useRuleStore } from "./RuleStore";

interface SingleRuleGridProps {
	/** the index of this rule */
	index: number;
}

const SingleRuleGrid: FunctionComponent<SingleRuleGridProps> = observer((props) => {
	const ruleStore = useRuleStore();
	const loc = useLocale();

	const {
		index,
	} = props;

	const {
		options,
		count,
		selectedCondition,
		setSelectedAttribute,
		setSelectedOperator,
		removeRule,
	} = ruleStore || {};

	const currentRule = ruleStore.ruleMap[index] as Rule;

	const {
		createValueStore,
		item,
		loading,
		operators,
		selectedOperator,
		selectedValues,
		spec,
		valueList,
		onChangeValueMultiSelect,
	} = currentRule || {};

	// do the localization
	const querySpecType = spec.querySpec.type;
	const isTime = querySpecType === "time";

	const _getLocalization = (id: string): string => {
		return loc.resource(isTime ? `OP_${id}_TIME` : `OP_${id}`);
	};

	selectedOperator.name = _getLocalization(selectedOperator.id);

	for (const operator of operators) {
		operator.name = _getLocalization(operator.id);
	}


	return (
		<Fragment>
			{!_.isEmpty(options) && (
				<Grid item xs={3}>
					<SingleSelect
						disableClearable
						forcePopupIcon
						groupBy={(option) => option.group}
						onChange={(event, value, reason) => setSelectedAttribute(value as ComponentItem, index)}
						options={options}
						value={item}
					/>
				</Grid>
			)}
			{!_.isEmpty(operators) && (
				<Grid item xs={3}>
					<SingleSelect
						fullWidth
						onChange={(event, newValueItem, reason) => setSelectedOperator(newValueItem, index)}
						options={operators}
						required
						value={selectedOperator}
					/>
				</Grid>
			)}
			<Grid item xs={4}>
				<MultiSelect
					allowCustomOptions
					limitTags={4}
					loading={loading}
					onChange={onChangeValueMultiSelect}
					onOpenCallback={createValueStore}
					options={valueList}
					placeHolderRes="AttributeValues"
					value={selectedValues}
				/>
			</Grid>
			<Grid item>
				<IconButton
					design="outline"
					onClick={() => removeRule(index)}
					size="large"
				>
					<ClearIcon />
				</IconButton>
			</Grid>
			{count > 1 && (
				<Grid item style={{ marginLeft: 10 }}>
					<Chip res={selectedCondition.id} />
				</Grid>
			)}
		</Fragment>
	);
});

export default SingleRuleGrid;